import PropTypes from "prop-types";

import DeleteButton from "@/components/Header/Button/DeleteButton";
import InfoButton from "@/components/Header/Button/InfoButton";
import HeaderButtonList from "@/components/Header/HeaderButtonList/HeaderButtonList";
import { BUTTON_TYPE, BUTTON_KEYS } from "@/constants/Button";
import { isSector } from "@/entities/location";
import { useAuthorization } from "@/modules/authorization";
import LocationEdit from "@/modules/location/location-edit";
import LocationInfo from "@/modules/location/location-info";
import { useSidePanel } from "@/modules/side-panel";
import { EditButton } from "@/ui/edit-button";

const HeaderButtons = ({ location = {} }) => {
  const { openSidePanel } = useSidePanel();
  const { canUpdate, canDelete } = useAuthorization();

  const onEditClick = () => {
    openSidePanel({
      title: location.name,
      component: <LocationEdit locationId={location.id} />,
    });
  };

  const onInfoSelect = () => {
    openSidePanel({
      title: location.name,
      component: <LocationInfo location={location} />,
    });
  };

  const primaryActions = [];
  primaryActions.push(<InfoButton key="info" onInfoSelect={onInfoSelect} />);

  const secondaryActions = [];

  if (canUpdate(location)) {
    secondaryActions.push({
      key: BUTTON_KEYS.EDIT,
      label: (
        <EditButton key={BUTTON_KEYS.EDIT} type="text" onClick={onEditClick} />
      ),
    });
  }

  if (canDelete(location)) {
    secondaryActions.push({
      key: BUTTON_KEYS.DELETE,
      label: (
        <DeleteButton
          key={BUTTON_KEYS.DELETE}
          modelKey={isSector(location) ? "sector" : "location"}
          model={location}
          buttonProps={{
            type: BUTTON_TYPE.TEXT,
          }}
        />
      ),
    });
  }

  return (
    <HeaderButtonList
      primaryActions={primaryActions}
      secondaryActions={secondaryActions}
    />
  );
};

HeaderButtons.propTypes = {
  location: PropTypes.object.isRequired,
};

export default HeaderButtons;
